// define an action in Redux is to separately declare an action type
export const openToastify = (value, eId) => {
  //// console.log('action', value)
  return {
    type: "OPENTOASTIFY",
    payload: value,
    id: eId,
  }
}
